const userAgentString = navigator.userAgent;

const isiOS = () => {
    return (/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window.MSStream;
}

const isIE = () => {
    return navigator.appName === 'Microsoft Internet Explorer' ||
        !!(userAgentString.match(/Trident/) ||
            userAgentString.match(/MSIE/) ||
            userAgentString.match(/rv:/)) ||
        (typeof $.browser !== "undefined" && $.browser.msie === 1);
}

const isChrome = () => {
    return userAgentString.indexOf('Chrome') > -1;
}

const isFirefox = () => {
    return userAgentString.indexOf('Firefox') > -1;
}

const isSafari = () => {
    let safariAgent = userAgentString.indexOf('Safari') > -1;

    // Discard Safari since it also matches Chrome
    if (isChrome() && safariAgent) safariAgent = false;

    return safariAgent;
}

exports.isiOs = isiOS;
exports.isIE = isIE;
exports.isChrome = isChrome;
exports.isFirefox = isFirefox;
exports.isSafari = isSafari;
